import { ITheme } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

import { mediaQuery } from '../../utils/styles';

const useStyles = createUseStyles<string, { isMobile: boolean; BGColor: string }>(
  ({ breakpoints }: ITheme) => ({
    header: {
      padding: (props: any) => (props.isMobile ? '0px 0 253px 0' : '0px 40px 253px 40px'),
      height: (props: any) => (props.isMobile ? '40%' : '55%'),
      background: (props: any) => props.BGColor,
    },
    footer: {
      height: (props: any) => (props.isMobile ? '60%' : '45%'),
      background: '#fff',
    },
    breadcrumbContainer: {
      paddingLeft: 40,
      paddingBottom: 16,
      [mediaQuery(breakpoints.tablet)]: {
        paddingLeft: 24,
      },
    },
    title: {
      fontSize: (props: any) => (props.isMobile ? 36 : 42),
      textAlign: 'center',
      color: '#fff',
      fontWeight: 500,
      lineHeight: '50px',
      marginTop: 30,
    },
    description: {
      fontSize: (props: any) => (props.isMobile ? 14 : 16),
      textAlign: 'center',
      color: '#fff',
      fontWeight: '500',
      width: (props: any) => (props.isMobile ? 'auto' : 660),
      lineHeight: (props: any) => (props.isMobile ? '20px' : '24px'),
      margin: (props: any) => (props.isMobile ? '0 auto' : '16px auto 0px'),
      padding: (props: any) => (props.isMobile ? '0 12px' : '0'),
    },
    wrapper: {
      margin: '0 auto',
      minWidth: (props: any) => (props.isMobile ? 'auto' : 1200),
      maxWidth: (props: any) => (props.isMobile ? 'auto' : 1436),
      position: 'relative',
      overflow: (props: any) => (props.isMobile ? 'hidden' : 'unset'),
      paddingBottom: 20,
      marginTop: (props: any) => (props.isMobile ? -213 : -213),
    },
    container: {
      padding: (props: any) => (props.isMobile ? '0' : '42px 61px'),
      margin: (props: any) => (props.isMobile ? '0 15px' : '30px 40px'),
      borderRadius: 32,
      filter: (props: any) =>
        props.isMobile ? 'none' : 'drop-shadow(0px 4px 16px rgba(17, 18, 54, 0.16))',
      background: '#fff',
      boxShadow: (props: any) => (props.isMobile ? '0px 4px 16px rgba(17, 18, 54, 0.16)' : 'none'),
    },
    section: {
      marginBottom: '48px',
    },
    ctaButton: {
      padding: '14px 32px',

      '& svg': {
        width: '24px !important',
        height: '24px !important',
        maxWidth: '24px !important',
        maxHeight: '24px !important',
      },
    },
    breadcrumb: {
      paddingTop: 12,
    },
  }),
  { name: 'main-section' },
);

export default useStyles;
